import request from '@/utils/request'
import {
  ConfirmErpInboundsReq,
  DeleteErpInboundsReq,
  DeleteErpInboundsRes,
  ErpInboundItem,
  GetErpInboundsReq,
  SaveErpInboundsReq,
  SaveErpInboundsRes,
} from './types'

/**
 * EGR01 일반입고(ERP) 화면 엔드포인트. 전부 moms-be(2.0)다.
 *
 * | 동작 | 2.0 API | 1.0 AS-IS | 근거 |
 * | --- | --- | --- | --- |
 * | 조회 | POST /api/v1/get-erp-inbounds | /api/grid/search (MENU_CD=EGR01_HEAD) | LOGISPRD-9556 |
 * | 저장 | POST /api/v1/erp/request-inbound | `handleSaveV2`(FilterBar `isUseV2API`) 로 같은 경로 | LOGISPRD-11243 |
 * | 삭제 | POST /api/v1/delete-erp-inbounds | /api/EGR01 (API_NM=RM_ASN_IN_OMS) | LOGISPRD-9557 |
 * | 엑셀 | POST /api/v1/get-erp-inbounds/excel | ag-Grid 클라이언트 Export | LOGISPRD-9558 |
 * | 확정 | POST /api/v1/erp/confirm-inbound | /api/EGR01 | ErpInboundController |
 */
export const ERP_INBOUNDS_URL = '/api/v1/get-erp-inbounds'
/** 엑셀 다운로드 URL. 화면이 다운로드 유틸(blob 저장)에 직접 넘기므로 이 모듈에는 호출 함수를 두지 않는다. */
export const ERP_INBOUNDS_EXCEL_URL = `${ERP_INBOUNDS_URL}/excel`
export const ERP_INBOUNDS_DELETE_URL = '/api/v1/delete-erp-inbounds'
export const ERP_INBOUNDS_CONFIRM_URL = '/api/v1/erp/confirm-inbound'
/**
 * 저장 엔드포인트. `/api/v1/request-inbound`(일반입고 경로)가 아니다 — EGR01 조회가
 * `IIF_BAM_ASN` 과 `IIF_MOMSAN_TYPE1` 을 INNER JOIN 해서 읽는데 그 경로는 `IIF_BAM_ASN` 을
 * 안 써서 저장한 행이 목록에서 사라진다(`InboundPlanErpJpaRepository.kt`).
 */
export const ERP_INBOUNDS_SAVE_URL = '/api/v1/erp/request-inbound'

/**
 * 일반입고(ERP) 목록 조회.
 *
 * ERP 미전송 건(IIF_BAM_ASN.API_FLAG = FALSE)만 대상이며 고정 조건은 서버가 건다.
 * 물류운영팀 계정이면 서버가 로그인 이메일로 UPD_BY 를 추가로 걸러 준다(1.0 FILTER_DEPT 대체).
 */
export const getErpInbounds = (params: GetErpInboundsReq) =>
  request.post<ApiPaginationV2<ErpInboundItem>, GetErpInboundsReq>(ERP_INBOUNDS_URL, params)

/**
 * 선택 행 삭제. 성공 건수만 돌려준다.
 * 요청 항목의 키가 대문자인 것은 BE `@JsonProperty` 계약이다(1.0 컬럼명 유지).
 */
export const deleteErpInbounds = (params: DeleteErpInboundsReq) =>
  request.post<ApiResponseV2<DeleteErpInboundsRes>, DeleteErpInboundsReq>(ERP_INBOUNDS_DELETE_URL, params)

/** 선택 행 입고확정. 확정된 입고예정 id 목록을 돌려준다. */
export const confirmErpInbounds = (params: ConfirmErpInboundsReq) =>
  request.post<ApiResponseV2<{ items: number[] }>, ConfirmErpInboundsReq>(ERP_INBOUNDS_CONFIRM_URL, params)

/**
 * 선택 행 저장. 행 단위 결과(`T_RESULT[].MSGTYP`)가 섞여 올 수 있다 — 화면이 `'S'` 아닌 행을
 * 실패로 판정한다(`useSaveErpInbounds`).
 */
export const saveErpInbounds = (params: SaveErpInboundsReq) =>
  request.post<ApiResponseV2<SaveErpInboundsRes>, SaveErpInboundsReq>(ERP_INBOUNDS_SAVE_URL, params)
